










import Vue from 'vue';
import ErrorStateImage from '@/Webchat/components/errorStateImage.vue';
export default Vue.extend({
    name: "ErrorState",
    components: {
        ErrorStateImage
    }
});
